import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serverList, getActivityList, activitySend, getActivitySendData } from "@/api/gmtool/packageCode";
import listviewfileActivities from "./components/listviewfileActivities";
import { gmTool } from "@/mixins/index";
import activities from "./mixins/activities";
export default {
  name: "listActivities",
  mixins: [gmTool, activities],
  components: {
    listviewfileActivities: listviewfileActivities
  },
  data: function data() {
    return {
      tableData: [],
      serverLists: []
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.getserverList();

              _this.$bus.$on("AcList", function () {
                _this.getList(_this.paramsData.page);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    editingAc: function editingAc(row) {
      this.lodclickOperationLog("update-activity", this.$t('clickModifyActivityBtn'));
      this.$emit("editingAc", row);
    },
    publishAc: function publishAc(row) {
      var _this2 = this;

      this.lodclickOperationLog("publish-btn-activity", this.$t('clickPublishActivityBtn'));
      activitySend({
        id: row.id
      }).then(function (res) {
        if (res.status == 200) {
          if (res.data.length) {
            _this2.$message.success(_this2.$t('publishSuccessWithServerWarning', {
              servers: res.data.toString()
            }));
          } else {
            _this2.$message.success(_this2.$t('publishSuccess'));
          }

          _this2.getList(_this2.paramsData.page);
        }
      });
    },
    switchProd: function switchProd() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.tableData = [];
                _context3.next = 3;
                return _this3.getserverList();

              case 3:
                _this3.getList(1);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getList: function getList(e) {
      var _this4 = this;

      this.paramsData.page = e;
      this.reqLoading = true;
      getActivityList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          res.data.data.map(function (i) {
            var server_list = i.server_list.split(",");
            var list = [];

            _this4.serverLists.forEach(function (k) {
              if (server_list.findIndex(function (j) {
                return j == k.serverID;
              }) > -1) {
                list.push(k.serverName);
              }
            });

            i.server_list_name = list.length ? list.toString() : "/";
          });
          _this4.tableData = res.data.data;
          _this4.total = res.data.total;
        }
      }).finally(function () {
        _this4.reqLoading = false;
      });
    },
    getserverList: function getserverList() {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        serverList({
          is_prod: _this5.paramsData.is_prod
        }).then(function (res) {
          if (res.status == 200) {
            _this5.serverLists = res.data;
          }
        }).finally(function () {
          resolve();
        });
      });
    },
    handleDelete: function handleDelete(row) {
      var _this6 = this;

      this.lodclickOperationLog("del-activity", this.$t('clickDeleteActivityBtn'));
      this.$confirm(this.$t('confirmDelete'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                delActivityList({
                  id: row.id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this6.getList(_this6.paramsData.page);

                    _this6.$message({
                      type: "success",
                      message: _this6.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    }
  }
};